<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.inserer :'' "
      iconClass="sprite-add-text"
      @click.native="insertText"
    />
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.police :'' "
      iconClass="sprite-text"
      @click.native="openFont=true"
      :class="{disabled:!isText}"
    />
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.taille : ''"
      iconClass="sprite-size"
      @click.native="openSlider('sliderSizeConfig')"
      :class="{disabled:!isText}"
      ref="sliderFontButton"
    /> 
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.interligne : ''"
      iconClass="sprite-interline"
      @click.native="openSlider('sliderInterlineConfig')"
      :class="{disabled:!isText}"
      ref="sliderInterlineButton"
    />
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.couleur : ''"
      iconClass="sprite-color"
      @click.native="openColor=true"
      :class="{disabled:!isText}"
    />
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.alignement :'' "
      :iconClass="'sprite-align-'+alignementList[currentAlignement]"
      @click.native="changeAlignement"
      :class="{disabled:!isText}"
    />
    <span class="separator"/>
    <button-text-style
      value="bold"
      :label="dictionnary ? dictionnary.textMenu.gras : ''"
      iconClass="sprite-bold"
      @click="onVariant"
      :class="{disabled:!isText}"
    />
    <button-text-style
      value="italic"
      :label="dictionnary ? dictionnary.textMenu.italique :'' "
      iconClass="sprite-italic"
      @click="onVariant"
      :class="{disabled:!isText}"
    />
    <button-text-style
      value="underline"
      :label="dictionnary ? dictionnary.textMenu.souligne : ''"
      iconClass="sprite-underline"
      @click="onVariant"
      :class="{disabled:!isText}"
    />
    <button-menu
      :label="dictionnary ? dictionnary.textMenu.dropshadow : ''"
      iconClass="sprite-shadow"
      @click.native="createShadow"
      ref="buttonShadow"
      :class="{disabled:!isText}"
    />
    <color-modal :open="openColor" @close="openColor=false" @changeColor="updateColor"/>
    <font-modal :open="openFont" @close="openFont=false" @selectFont="updateFont"/>
    <transition name="fade">
      <slider
        ref="slider"
        :config="sliderConfig"
        v-if="showSlider"
        @close="showSlider=false"
        @input="updateSliderValue"
      />
    </transition>
    <transition name="fade">
      <slider-drop-shadow :editor="editor" v-show="openShadow && isText" ref="shadow"/>
    </transition>
  </div>
</template>
<script>
import menu from './menu-default'
import ButtonMenu from '@/components/buttons/ButtonMenu'
import ButtonTextStyle from '@/components/buttons/ButtonTextStyle'
import Slider from '@/components/slider/Slider'
import ColorModal from '@/components/modal/ColorModal'
import FontModal from '@/components/modal/FontModal'
import SliderDropShadow from '@/components/slider/SliderDropShadow'

import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TextMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    ButtonTextStyle,
    Slider,
    ColorModal,
    FontModal,
    SliderDropShadow
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    await this.dictionnary
    this.sliderSizeConfig = this.sliderSizeConfig
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      openColor: false,
      openFont: false,
      currentAlignement: 0,
      openShadow: false,
      alignementList: ['left', 'center', 'right'],
      showSlider: false,
      showSliderInterline:false,
      sliderConfig:null,
      currentConfig:'sliderSizeConfig',
      sliderSizeConfig: {
        icon: 'sprite-small-size',
        label: this.dictionnary ? this.dictionnary.textMenu.taille : '',
        min: 8,
        max: 100,
        value: 18,
        prop:'fontSize'
      },
      sliderInterlineConfig:{
        icon: 'sprite-small-interline',
        label: this.dictionnary ? this.dictionnary.textMenu.interligne : '',
        min: 0,
        max: 4,
        value: 1.16,
        prop:'lineHeight',
        step:0.1
      }
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getFontFormat', 'getCurrentColor'])
  },
  methods: {
    ...mapActions(['updateFontFormat']),
    updateColor(color) {
      if (this.editor.getCurrentSelectedObject() && this.editor.getCurrentSelectedObject().type === 'textbox') {
        this.editor.setColor(color)
        this.templateModified()
      }
    },
    insertText() {
      const format = { ...this.getFontFormat, fill: '#000' }
      this.editor.insertText(format)
      this.templateModified()
    },
    onVariant(item) {
      if (this.isText) {
        let val = null
        if (item.value === 'bold') {
          val = { fontWeight: item.selected ? 900 : 'normal' }
          this.updateFontFormat({ ...this.getFontFormat,...val })
        }
        if (item.value === 'italic') {
          val = { fontStyle: item.selected ? 'italic' : 'normal' }
          this.updateFontFormat({ ...this.getFontFormat, ...val })
        }
        if (item.value === 'underline') {
          val = { underline: item.selected }
          this.updateFontFormat({ ...this.getFontFormat, ...val })
        }
        this.updateFontValue(val)
      }
    },
    changeAlignement() {
      this.currentAlignement++
      if (this.currentAlignement >= this.alignementList.length) {
        this.currentAlignement = 0
      }
      this.updateFontFormat({ ...this.getFontFormat, textAlign: this.alignementList[this.currentAlignement] })
      this.updateFontValue({ textAlign: this.alignementList[this.currentAlignement] })
    },
    hideSlider(event) {
      if (this.$refs.slider && !this.$refs.slider.$el.contains(event.target) && !this.$refs.sliderFontButton.$el.contains(event.target)&& !this.$refs.sliderInterlineButton.$el.contains(event.target)) {
        this.showSlider = false
        window.removeEventListener('click', this.hideSlider)
      }
    },
    openSlider(config) {
     this.sliderConfig= this[config]
     this.currentConfig= config
      if (this.showSlider === false) {
        this.showSlider = true
       window.addEventListener('click', this.hideSlider)
      }
    },
    updateSliderValue(slider) {
      this[this.currentConfig].value = slider.value
      const valueUpdated = {}
      valueUpdated[this.sliderConfig.prop]= slider.value
      this.updateFontFormat({ ...this.getFontFormat, ...valueUpdated })
      this.updateFontValue(valueUpdated)
    },
    updateFont(font) {
      this.updateFontFormat({ ...this.getFontFormat, fontFamily: font })
      this.updateFontValue({ fontFamily: font })
      this.openFont = false
    },
    updateFontValue(value) {
      this.editor.updateTextBox(value)
      this.templateModified()
    },
    createShadow() {
      this.openShadow = !this.openShadow
      if (this.openShadow) {
        const x = this.$refs.buttonShadow.$el.offsetLeft + this.$refs.buttonShadow.$el.clientWidth / 2 - 282 / 2
        this.$refs.shadow.$el.style.left = x + 'px'
        this.$refs.buttonShadow.$el.classList.add('button-menu-selected')
      } else {
        this.$refs.buttonShadow.$el.classList.remove('button-menu-selected')
      }
    }
  },
  watch: {
    isText: function(n, o) {
      if (!n && this.openShadow) {
        this.openShadow = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/TextMenu.vue